<div
    *ngIf="!child"
    [ngClass]="{'cipafacil-horizontal-navigation-menu-active': trigger.menuOpen,
                 'cipafacil-horizontal-navigation-menu-active-forced': item.active}"
    [matMenuTriggerFor]="matMenu"
    (onMenuOpen)="triggerChangeDetection()"
    (onMenuClose)="triggerChangeDetection()"
    #trigger="matMenuTrigger">
    <ng-container *ngTemplateOutlet="itemTemplate; context: {$implicit: item}"></ng-container>
</div>

<mat-menu
    class="cipafacil-horizontal-navigation-menu-panel"
    [overlapTrigger]="false"
    #matMenu="matMenu">

    <ng-container *ngFor="let item of item.children">

        <!-- Skip the hidden items -->
        <ng-container *ngIf="(item.hidden && !item.hidden(item)) || !item.hidden">

            <!-- Basic -->
            <div
                class="cipafacil-horizontal-navigation-menu-item"
                *ngIf="item.type === 'basic'"
                [disabled]="item.disabled"
                mat-menu-item>
                <cipafacil-horizontal-navigation-basic-item
                    [item]="item"
                    [name]="name"></cipafacil-horizontal-navigation-basic-item>
            </div>

            <!-- Branch: aside, collapsable, group -->
            <div
                class="cipafacil-horizontal-navigation-menu-item"
                *ngIf="item.type === 'aside' || item.type === 'collapsable' || item.type === 'group'"
                [disabled]="item.disabled"
                [matMenuTriggerFor]="branch.matMenu"
                mat-menu-item>
                <ng-container *ngTemplateOutlet="itemTemplate; context: {$implicit: item}"></ng-container>
                <cipafacil-horizontal-navigation-branch-item
                    [child]="true"
                    [item]="item"
                    [name]="name"
                    #branch></cipafacil-horizontal-navigation-branch-item>
            </div>

            <!-- Divider -->
            <div
                class="cipafacil-horizontal-navigation-menu-item"
                *ngIf="item.type === 'divider'"
                mat-menu-item>
                <cipafacil-horizontal-navigation-divider-item
                    [item]="item"
                    [name]="name"></cipafacil-horizontal-navigation-divider-item>
            </div>

        </ng-container>

    </ng-container>

</mat-menu>

<!-- Item template -->
<ng-template
    let-item
    #itemTemplate>

    <div
        class="cipafacil-horizontal-navigation-item-wrapper"
        [class.cipafacil-horizontal-navigation-item-has-subtitle]="!!item.subtitle"
        [ngClass]="item.classes?.wrapper">

        <div
            class="cipafacil-horizontal-navigation-item"
            [ngClass]="{'cipafacil-horizontal-navigation-item-disabled': item.disabled,
                         'cipafacil-horizontal-navigation-item-active-forced': item.active}">

            <!-- Icon -->
            <mat-icon
                class="cipafacil-horizontal-navigation-item-icon"
                [ngClass]="item.classes?.icon"
                *ngIf="item.icon"
                [svgIcon]="item.icon"></mat-icon>

            <!-- Title & Subtitle -->
            <div class="cipafacil-horizontal-navigation-item-title-wrapper">
                <div class="cipafacil-horizontal-navigation-item-title">
                    <span class="flex items-center" [ngClass]="item.classes?.title">
                        {{item.title}}

                        <mat-icon *ngIf="item.type === 'group'" class="icon-size-4 ml-2" [svgIcon]="'awesome_solid:angle-down'"></mat-icon>
                    </span>
                </div>
                <div
                    class="cipafacil-horizontal-navigation-item-subtitle text-hint"
                    *ngIf="item.subtitle">
                    <span [ngClass]="item.classes?.subtitle">
                        {{item.subtitle}}
                    </span>
                </div>
            </div>

            <!-- Badge -->
            <div
                class="cipafacil-horizontal-navigation-item-badge"
                *ngIf="item.badge">
                <div
                    class="cipafacil-horizontal-navigation-item-badge-content"
                    [ngClass]="item.badge.classes">
                    {{item.badge.title}}
                </div>
            </div>
        </div>
    </div>

</ng-template>
